import styled from 'styled-components';

export const ScrollSentinel = styled.div`
    min-height: 40px;
`;
